import React, { useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { NavLink } from "react-router-dom";
import config from "../../Config";
import SessionsDropDown from "../Shared/SessionsDropDown";
import WingsDropDown from "../Shared/WingsDropDown";
import ClassesDropDown from "../Shared/ClassesDropDown";
import TimeTableMenu from "./TimeTableMenu";
import { scrollToTop } from "../Shared/ScrollOnTop";

function TimeTableCoverage() {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(parseInt(localStorage.getItem("ID"), 10) || 0);
  const [MemberType] = useState(localStorage.getItem("MemberType") || "Admin");

  const [SessionId, setSessionId] = useState(localStorage.getItem("DefaultSession") || "0");
  const [WingId, setWingId] = useState(0);
  const [ClassId, setClassId] = useState(0);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadCoverage = () => {
    if (!(parseInt(SessionId, 10) > 0 && parseInt(ClassId, 10) > 0)) {
      toast.error("Select session and class.");
      return;
    }
    setLoading(true);
    axios
      .post(config.base_url + "TimeTable/GetSectionTimeTableCoverage", {
        AccessKey,
        UserID,
        MemberType,
        SessionID: parseInt(SessionId, 10),
        SchoolID: 1,
        Wing_Id: parseInt(WingId, 10) || 0,
        Class_Id: parseInt(ClassId, 10),
      })
      .then((res) => {
        if (res.data.status_code === 1) setRows(res.data.ListofRecords || []);
        else {
          setRows([]);
          toast.error(res.data.status_message || "Failed to load coverage.");
        }
      })
      .catch(() => toast.error("Network error."))
      .finally(() => setLoading(false));
  };

  const badgeClass = (status) => {
    if (status === "Complete") return "badge bg-success";
    if (status === "Header Only") return "badge bg-warning text-dark";
    return "badge bg-danger";
  };

  return (
    <>
      <TimeTableMenu />
      <ToastContainer />
      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-8">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/Dashboard" onClick={scrollToTop}>Dashboard</NavLink>
                    </li>
                    <li className="breadcrumb-item active">Time Table Coverage</li>
                  </ol>
                </nav>
                <div className="page-title">Time Table Coverage Report</div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content mt-3">
          <div className="container">
            <div className="card mb-3">
              <div className="card-body">
                <div className="row g-2">
                  <div className="col-md-3">
                    <label className="form-label">Session</label>
                    <select className="form-select" value={SessionId} onChange={(e) => setSessionId(e.target.value)}>
                      <option value="0">Select</option>
                      <SessionsDropDown selectedSession={parseInt(SessionId, 10) || 0} />
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Wing</label>
                    <select className="form-select" value={WingId} onChange={(e) => { setWingId(parseInt(e.target.value, 10) || 0); setClassId(0); }}>
                      <option value="0">All Wings</option>
                      <WingsDropDown selectedWingId={WingId} />
                    </select>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Class</label>
                    <select className="form-select" value={ClassId} onChange={(e) => setClassId(parseInt(e.target.value, 10) || 0)}>
                      <option value="0">Select</option>
                      <ClassesDropDown WingID={WingId} SessionID={parseInt(SessionId, 10) || 0} selectedClassId={ClassId} />
                    </select>
                  </div>
                  <div className="col-md-3 d-flex align-items-end">
                    <button className="button button-primary w-100" onClick={loadCoverage}>Load Coverage</button>
                  </div>
                </div>
              </div>
            </div>

            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-theme table-sm">
                    <thead>
                      <tr>
                        <th>Section</th>
                        <th>Status</th>
                        <th>Headers</th>
                        <th>Rows</th>
                        <th>Active</th>
                        <th>Latest</th>
                        <th>Effective</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!loading && rows.length === 0 ? (
                        <tr><td colSpan="8" className="text-muted">No data. Select filters and load coverage.</td></tr>
                      ) : null}
                      {rows.map((r) => (
                        <tr key={r.Section_ID}>
                          <td>{r.Section_Name}</td>
                          <td><span className={badgeClass(r.CoverageStatus)}>{r.CoverageStatus}</span></td>
                          <td>{r.HeaderCount}</td>
                          <td>{r.DetailRows}</td>
                          <td>{r.HasActive ? "Yes" : "No"}</td>
                          <td>{r.LatestTimeTable_Name || "-"}</td>
                          <td>{r.LatestEffectiveFrom ? `${r.LatestEffectiveFrom}${r.LatestEffectiveTo ? ` to ${r.LatestEffectiveTo}` : ""}` : "-"}</td>
                          <td>
                            <NavLink
                              onClick={scrollToTop}
                              to={`/timetable/TimeTableManagement?tab=timetable&sessionId=${encodeURIComponent(SessionId)}&wingId=${encodeURIComponent(WingId)}&classId=${encodeURIComponent(ClassId)}&sectionId=${encodeURIComponent(r.Section_ID)}`}
                            >
                              Open
                            </NavLink>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default TimeTableCoverage;
